import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@material-ui/core/TextField';
// import Input from '../Input/Input';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const NameScheduleForm = ({ values, handleChange }) => (
  <React.Fragment >
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <TextField
        data-tut="reactour__descrever"
        name="description"
        label="Descrição"
        value={values.description}
        onChange={handleChange('description')}
        style={{ minWidth: '50%' }}
        required
      />
      {/* <Input
        elementType="timePicker"
        label="Horário de fechamento"
        required={false}
        value={values.horaryClosing || 'Fri Oct 02 2020 05:30:00 GMT-0300 (Horário Padrão de Brasília)'}
        onChange={handleChangeHour}
      /> */}
    </div>
    <FormControlLabel
      control={
        <Checkbox
          color="primary"
          name="isRotation"
          checked={values.isRotation}
          onChange={handleChange('isRotation')}
        />
      }
      label="A escala possui revezamento"
    />
    <FormControlLabel
      control={
        <Checkbox
          color="primary"
          name="isZeroScale"
          checked={values.isZeroScale}
          onChange={handleChange('isZeroScale')}
        />
      }
      label="Escala Flexível"
    />
  </React.Fragment>
);

NameScheduleForm.propTypes = {
  values: PropTypes.shape({
    description: PropTypes.string.isRequired,
    isRotation: PropTypes.bool.isRequired,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default NameScheduleForm;
